import TextField from '@mui/material/TextField';
import { useState } from 'react';
import globals from '../../globals';

const EmailField = ({onChange}) => {
    const [focused, setFocused] = useState(false);
    const [value, setValue] = useState('');

    return (
        <TextField
            id="email"
            label={focused || value ? '' : 'Имейл адрес'}
            variant="outlined"
            value={value}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            onChange={(e) => {
                setValue(e.target.value);
                if (onChange) {
                    onChange(e);
                }
            }}
            sx={{
                backgroundColor: globals.colors.backgroundColor,
                borderRadius: 1,
                color: globals.colors.textColor,
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: globals.colors.darkRed, // default border color
                    },
                    '&:hover fieldset': {
                        borderColor: globals.colors.darkRed, // border color on hover
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: globals.colors.darkRed, // border color when focused
                    },
                },
            }}
            size="medium"
        />
    );
};

export default EmailField;